import s from "./Error.module.css";

const Error = () => {
  return (
    <>
      <div className={s.error}>NOT FOUND😥</div>
    </>
  );
};

export default Error;
